export default __webpack_public_path__ + "static/media/review.f1f4a2a3.svg";